module.exports = __webpack_public_path__ + "img/dk_hight.76c9ea48.png";